
export default function TermoOfertas(){


    return (
       <text>
      
      <p className="font-mail mt-3">
                        <b>CONFIRMANDO</b> esta etapa de reativação dos serviços da contratada NETSIM PROVEDOR DE SISTEMA DE INTEGRAÇÃO A MIDIA - LTDA de CNPJ 18.156.287/0001-09, você tem total ciência que:
                    </p> <ul>
                        <li>Está contratando um plano internet de <b>R$19,90</b> apenas nas 3 primeiras mensalidades. Suporte gratuito, equipamentos gratuito e instalação gratuita.</li>
                        <li>Esta assinando um contrato de fidelidade de 12 meses.</li>
                        <li>Que fez todas as confirmações e envio dos dados necessários para realização do cadastro por meio eletrônico, ligação, whatsapp e outros.</li>
                        <li>Que a empresa tem um prazo máximo para instalação de até 48 horas. </li>
                        <li>Que todos os dados fornecidos estão seguros e são de inteira responsabilidade da Netsim Telecom e serão usados apenas para assinatura do plano internet.</li>

                    </ul>
                    
       </text> 
    )
}

